/* eslint-disable arrow-body-style */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import keygen from '~helpers/keygen';
import Item from './item';
import styles from './items.module.scss';

const addPositionClass = ({ target }) => {
  for (const element of target?.children) {
    if (element?.tagName === 'UL' && element?.className === styles.subMenuList) {
      const { left, width } = element.getBoundingClientRect();
      left + width > document.body.clientWidth &&
        element.classList.add(styles.staticLeft, styles.hoverLeft);
      break;
    }
  }
};

// Test included with menu molecule test
const Items = ({
  item,
  menuListRef,
  options = {
    mobile: {
      canOpenAllSubMenus: false,
      subMenuDropDownButton: true,
    },
  },
  gtmClass = '',
}) => {
  let link;
  let menu;

  const subMenuList = useRef(null);

  function showSubMenu(itemStyles) {
    if (!options.mobile.canOpenAllSubMenus) {
      const showingSubMenu = menuListRef.current.querySelector(`.${styles.show}`);

      if (showingSubMenu && showingSubMenu !== subMenuList.current) {
        showingSubMenu.classList.toggle(styles.show);

        if (itemStyles !== null) {
          if (options.mobile.subMenuDropDownButton) {
            showingSubMenu.parentNode.querySelector('button').classList.toggle(itemStyles.active);
          }
        }
      }
    }

    if (subMenuList.current) {
      subMenuList.current.classList.toggle(styles.show);
    }
  }

  if (item.children) {
    link = (
      <Item
        hasChildren
        item={item}
        showSubMenuHandler={showSubMenu}
        gtmClass={gtmClass}
        options={{
          mobile: {
            subMenuDropDownButton: options.mobile.subMenuDropDownButton,
          },
        }}
      />
    );
    menu = (
      <ul ref={subMenuList} className={styles.subMenuList}>
        {item.children.map((child) => {
          return (
            <Items
              key={keygen()}
              item={child}
              menuListRef={menuListRef}
              gtmClass={gtmClass}
              options={{
                mobile: {
                  canOpenAllSubMenus: options.mobile.canOpenAllSubMenus,
                  subMenuDropDownButton: options.mobile.subMenuDropDownButton,
                },
              }}
            />
          );
        })}
      </ul>
    );
  } else {
    link = (
      <Item
        hasChildren={false}
        item={item}
        gtmClass={gtmClass}
        options={{ mobile: { subMenuDropDownButton: options.mobile.subMenuDropDownButton } }}
      />
    );
  }

  return (
    <li className={styles.menuItem} onMouseEnter={addPositionClass}>
      {link}
      {menu}
    </li>
  );
};

Items.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string,
      })
    ),
  }).isRequired,
  menuListRef: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
  options: PropTypes.shape({
    mobile: PropTypes.shape({
      canOpenAllSubMenus: PropTypes.bool,
      subMenuDropDownButton: PropTypes.bool,
    }),
  }),
  gtmClass: PropTypes.string,
};

export default Items;
